<template>
    <div class="leadFirst">
        <div class="header_box">
        <!-- 头部搜索框 -->
        <div class="search">
            <input type="text" class="search_key" :placeholder="formData.hold" v-model="formData.inputParams" />
            <span class="search_btn" @click="startSearch">查询</span>
            <img src="../../../../../assets/image/search.png" class="search_img" />
        </div>
        </div>
        <div class="main_header">
            <!-- 头部tab切换 -->
            <div class="header_tab">
                <div class="tab" v-for="(t,index) in tab" :key="index" :class="{tabColor:index == tabNum,'tabLeft':index ===0,'tabRight':index===4}" @click="tabClick(index)">{{t}}</div>
            </div>
        </div>
        <div class="main_check"  v-show="tabNum !== 0 && isNolist!==true">
            <BetterScroll class="top_title" :scrollX="true" :data="cityList" v-if="true" ref="wrapper1">
                <div class="wrapper1">
                    <div
                        class="item"
                        v-for="(item,index) in cityList"
                        :key="index"
                        :class="{'item_active':item.select}"
                        @click="changeCity(item,index)"
                        >
                        <p :class="{'p_active':item.select}" >{{item.city}}</p>
                        <p>
                            <span :class="{'t_active':item.select}">{{item.value}}</span>
                            <span :class="{'t_active':item.select}">起</span>
                        </p>
                    </div>
                </div>
            </BetterScroll>
            <div class="pro_detail">
                <div class="all_city" v-if="true" ref="allCity" :class="{'all_active':isShow}">
                    <p class="t_txt">全部地区</p>
                    <div class="pro1">
                        <div class="pro_item">
                            <div
                            class="pro"
                            v-for="(item,index) in cityList"
                            :key="index"
                            :class="{'pro_active':item.select}"
                            @click="changeCity(item,index)"
                            >
                            <p :class="{'p_active':item.select}">{{item.city}}</p>
                            <p>
                                <span :class="{'t_active':item.select}">{{item.value}}</span>
                                <span :class="{'t_active':item.select}">起</span>
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="tabNum == 0" class="header_text">
            <span>{{cityValue || 0}}</span>
            <span>起</span>
        </div>
        <div class="main_list" v-if="isNolist!==true">
            <div class="s_city" @click="changShow()" v-show="this.tabNum !== 0">
                <img src="../../../../../assets/image/select.png" v-if="!isShow" />
                <img src="../../../../../assets/image/no_select.png" v-if="isShow" />
            </div>
            <van-list
                ref="vanList"
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                @load="onLoad"
                class="wrapper"
            >
                <div
                class="reject"
                v-for="(item,index) in proList"
                :key="index"
                @click="goDetail(item)"
                >
                <div class="reject_item">
                    <div class="item_top">
                        <div class="title">
                        <p class="title_text">{{item.defendantName}}</p>
                        <p class="title_tag" :class="{'ss1': item.urgency === '一般'}" v-if="item.urgency === '一般'"> {{ item.urgency }}</p>
                        <p class="title_tag" :class="{'ss2': item.urgency === '较重'}" v-if="item.urgency === '较重'"> {{ item.urgency }}</p>
                        <p class="title_tag" :class="{'ss3': item.urgency === '严重'}" v-if="item.urgency === '严重'"> {{ item.urgency }}</p>
                        <!-- <p class="title_tag1" :class="sstt[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]">{{sttText[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]}}</p> -->
                        </div>
                        <div class="info1">
                            <span><img src="../../../../../assets/complaint/adress.png" alt=""></span><span>{{item.belongMechanismName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉人姓名:</span>
                            <span>{{item.complainName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉时间:</span>
                            <span>{{item.complainTime}}</span>
                        </div>
                        <div class="info">
                            <span>投诉单号:</span>
                            <span>{{item.mainComplainNumber}}</span>
                        </div>
                        <div class="info">
                            <span>处置状态:</span>
                            <span class="info_time">{{item.handleTime|filt3()}}</span>
                            <span></span>
                            <span>{{item.handleTimeLimit|filt4()}}</span>
                        </div>
                    </div>

                    <div class="line line_bottom"></div>
                    <div class="status">
                        <p>{{item.statueName}}</p>
                        <p>
                            <span>查看详情</span>
                            <span>
                                <img src="../../../../../assets/image/right.png" alt="">
                            </span>
                        </p>
                    </div>
                </div>
                </div>
            </van-list>
        </div>
        <isNoInfo :isNolist="isNolist" class="isNoBox"></isNoInfo>
    </div>
</template>
<script>
    import api from '../../../../../service/modules/complaintApis';
    import BetterScroll from '../../../../../components/base/betterScroll';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    import util from '../../../../../utils/common'
    export default {
        components: {
            BetterScroll,
            isNoInfo
        },
        data () {
            return {
                tab: ['省级', '州市', '区县', '企业'],
                tabNum: 0,
                sstt: [
                    'ss1',
                    'ss2',
                    'ss3'
                ],
                sttText: [
                    '一般',
                    '较重',
                    '严重'
                ],
                proList: [],
                pageIndex: '0',
                pageSize: '10',
                cityList: [],
                cityList1: [],
                cityList2: [],
                cityList3: [],
                cityList4: [],
                finished: false,
                finishedText: '没有更多',
                loading: true,
                isNolist: false,
                isShow: false,
                typeLevel: 1,
                cityValue: '',
                areaId: '',
                areaId1: this.$route.query.areaOne,
                pointType: this.$route.query.type,
                totalSize: '',
                formData:{
                  inputParams:'',
                  hold:'投诉单号/投诉人姓名/被投诉对象名称',
                },
            }
        },
        created () {
            this.getInfoList();
        },
        activated () {
            this.areaId1 = this.$route.query.areaOne;
        },
        methods: {
            startSearch(){
                this.getList(this.tabNum + 1);
            },
            // 跳转详情页
            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.$store.commit('complaint/setCheckList', false);
            },
            getInfoList () {
                api.leader.getNotCompletePoint({
                    pointType: this.pointType,
                    areaOne: this.areaId1
                }).then(res => {
                    if (res.ret === 0) {
                        // this.loading = false;
                        console.log('res.data.notComplainPoint:', res.data);
                        if (res.data.notComplainPoint.province.length !== 0) {
                            this.tabNum = 0;
                            this.cityValue = res.data.notComplainPoint.province[0].value;
                            this.areaId = res.data.notComplainPoint.province[0].area;
                            if (this.cityValue === '') {
                                this.isNolist = true;
                                this.cityValue = 0;
                            }
                            this.getList(this.tabNum + 1);
                            console.log('dddw', this.cityList)
                        } else if (res.data.notComplainPoint.city.length !== 0) {
                            this.tabNum = 1;
                            this.cityList = res.data.notComplainPoint.city;
                            this.cityList.map((item, index) => {
                                this.$set(item, 'select', false);
                            });

                            this.$set(this.cityList[0], 'select', true);
                            this.areaId = this.cityList[0].area;
                            this.getList(this.tabNum + 1);
                        } else if (res.data.notComplainPoint.county.length !== 0) {
                            this.tabNum = 2;
                            this.cityList = res.data.notComplainPoint.county;
                            this.cityList.map((item, index) => {
                                this.$set(item, 'select', false);
                            });
                            this.$set(this.cityList[0], 'select', true);
                            this.areaId = this.cityList[0].area;
                            this.getList(this.tabNum + 1);
                        } else if (res.data.notComplainPoint.enterprise.length !== 0) {
                            this.tabNum = 3;
                            this.cityList = res.data.notComplainPoint.enterprise;
                            this.cityList.map((item, index) => {
                                this.$set(item, 'select', false);
                            });
                            this.$set(this.cityList[0], 'select', true);
                            this.areaId = this.cityList[0].area;
                            this.getList(this.tabNum + 1);
                        } else {
                            this.getList(this.tabNum + 1);
                        }
                        this.cityList4 = res.data.notComplainPoint;
                    }
                });
            },
            tabClick (index) {
                console.log(index,'ceshi')
                this.tabNum = index;
                this.proList=[];
                if (this.tabNum === 0) {
                    this.cityList = this.cityList4.province;
                } else if (this.tabNum === 1) {
                    this.cityList = this.cityList4.city;
                    console.log('dddd', this.cityList)
                } else if (this.tabNum === 2) {
                    this.cityList = this.cityList4.county;
                    console.log('dddd1', this.cityList)
                } else if (this.tabNum === 3) {
                    this.cityList = this.cityList4.enterprise;
                    console.log('dddd2', this.cityList)
                }
                this.cityList.map((item, index) => {
                    if (index === 0) {
                        this.$set(this.cityList[index], 'select', true);
                    } else {
                        this.$set(this.cityList[index], 'select', false);
                    }
                });
                this.pageIndex = '1';
                this.changeCity(this.cityList[0], 0);
            },

            getList (value) {
                // this.proList = [];
                // this.cityList=[];
                this.proList=[];
                this.pageIndex = 1;
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    inputParams: this.formData.inputParams,
                    place: this.areaId,
                    dealType: this.pointType,
                    pointType: value
                }
                api.common.getComplainDealStateList(data).then(res => {
                    this.loading = false; // 加载参数
                    const list = (res.data || {}).list || [];
                    if (list.length > 0) { // 有数据
                        this.proList = list;
                        if (list.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                })
            },
            getMore () {
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    inputParams: '',
                    place: this.areaId,
                    dealType: this.pointType,
                    pointType: this.tabNum + 1
                }
                api.common.getComplainDealStateList(data).then((res) => {
                    const list = (res.data || {}).list || [];
                    if (list.length > 0) { // 有数据
                        this.proList = this.proList.concat(list);
                        if (this.proList.length === res.data.totalSize) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                })
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            },
            changeCity (item, index) {
                console.log(item,'测试');
                if(item){
                    this.areaId = item.area;
                }else{
                    this.areaId='';
                }
                
                 
                 this.getList(this.tabNum + 1);
                if (!item) {
                    this.isNolist = true;
                    this.loading = false;
                } else {
                    this.loading = false;
                    // this.areaId = item.area;
                    this.cityList.map((item, index) => {
                        this.$set(item, 'select', false);
                    });
                    this.$set(this.cityList[index], 'select', true);
                    this.isShow = false;
                    this.pageIndex = '1';
                    
                }
            },
            changShow () {
                this.isShow = !this.isShow;
            }
        },
        filters: {
            // 时长计算
            filt3 (value) {
                var theTime = parseInt(value);// 秒
                var middle= 0;// 分
                var hour= 0;// 小时

                if(theTime > 60) {
                    middle= parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(middle> 60) {
                        hour= parseInt(middle/60);
                        middle= parseInt(middle%60);
                    }
                }
                var result = ""+parseInt(theTime)+"秒";
                if(middle > 0) {
                    result = ""+parseInt(middle)+"分"+result;
                }
                if(hour> 0) {
                    result = ""+parseInt(hour)+"小时"+result;
                }
                return result;
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60 % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times
            }
        }
    }
</script>
<style lang="less" scoped>
.leadFirst {
    .header_box {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
        background-color: #fff;
        .search {
        width: 100%;
        position: relative;
        margin-top: 10px;
        margin-bottom: 10px;
        .search_key {
            width: 297px;
            height: 36px;
            background: #f8f8f8;
            border-radius: 18px;
            margin-left: 15px;
            font-size: 13px !important;
            padding-left: 39px;
            box-sizing: border-box;
            border: 0;
            outline: none;
            line-height: 36px;
        }
        .search_btn {
            font-size: 14px;
            margin-left: 16px;
        }
        .search_img {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 30px;
            top: 11px;
        }
        }
        .search_query {
        width: 100%;
        height: 42px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        border-bottom: 1px solid #eee;
        .item {
            flex: 1;
            text-align: center;
            line-height: 42px;
            .city {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #666;
            max-width: 110px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            }
            .jian {
            width: 6px;
            height: 4px;
            display: inline-block;
            vertical-align: middle;
            }
        }
        }
    }
    .main_header {
        width: 100%;
        height: 59px;
        background: #36B374;
        display: flex;
        align-items: center;
        position: fixed;
        top: 56px;
        z-index: 90;
        .header_tab {
            display: flex;
            align-items: center;
            width: 307px;
            margin: 0 34px;
            border-radius:2px 2px 2px 2px;
            // border:1px solid rgba(255,255,255,0.3);
            justify-content: space-around;
            .tab {
                height: 30px;
                width: 25%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color:rgba(255,255,255,1);
                background:rgba(54,179,116,1);
                border: 1px solid rgba(255, 255, 255, 0.3);
                border-right: none;

            }
            .tabLeft {
                border-radius: 2px 0 0 2px;
            }
            .tabRight {
                border-radius: 0 2px 2px 0;
            }
            &>div:nth-child(4){
                border-right:1px solid rgba(255, 255, 255, 0.3) !important;
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
            }
            .tabColor {
                height: 30px;
                width: 25%;
                text-align: center;
                line-height: 30px;
                font-size:14px;
                font-weight:400;
                color: #36B374;
                background:  rgba(255,255,255,1);
            }
        }
    }
    .main_check {
        margin-top: 101px;
        width: 100%;
        height: 100%;
        .top_title {
            height: 80px;
            width: 100%;
            overflow: hidden;
            position: fixed;
            background-color: #fff;
            z-index: 2;
            box-sizing: border-box;
            .wrapper1 {
                padding-top: 20px;
                white-space: nowrap;
                position: absolute;
                top: 0;
                .item {
                    display: inline-block;
                    height: 48px;
                    width: 85px;
                    border: 1px solid #efefef;
                    text-align: center;
                    border-radius: 4px;
                    margin-left: 10px;
                    p:nth-child(1) {
                        font-size: 12px;
                        line-height: 16px;
                        color: #999999;
                        margin-top: 8px;
                        width: 72px;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .p_active {
                        color: #fff !important;
                    }
                    p:nth-child(2) {
                        font-size: 13px;
                        margin-top: 4px;
                        span:nth-child(1) {
                            font-size: 13px;
                            color: #999999;
                        }
                        span:nth-child(2) {
                            font-size: 13px;
                            color: #999999;
                        }
                        .t_active {
                            color: #fff !important;
                        }
                    }
                }
                .item_active {
                    background-color: #36b374;
                    border: 1px solid #36b374;
                }
            }
            .wrapper1_date {
                text-align: center;
                width: 100%;
                font-size:14px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
                padding: 10px 0px;
            }
        }
        .pro_detail {
            width: 100%;
            padding-top: 90px;
            .all_city {
                padding-top: 20px;
                width: 100%;
                overflow: hidden;
                position: relative;
                transition: all 0.5s ease-in-out;
                margin-top: -100%;
                .t_txt {
                    width: 100%;
                    text-align: center;
                    font-size: 15px;
                    color: #000;
                    font-weight: 700;
                    // margin-top: 10px;
                }
                .pro1 {
                    width: 100%;
                    // padding: 0 16px;
                    box-sizing: border-box;
                    display: flex;
                    .pro_item {
                        width: 100%;
                        font-size: 0;
                        margin-top: 10px;
                        margin-bottom: 10px;
                        border-left: 1px solid #efefef;
                        box-sizing: border-box;
                        .pro:nth-child(-n + 5) {
                            border-top: 1px solid #efefef;
                        }
                        .pro {
                            display: inline-block;
                            width: 20%;
                            padding: 10px 0;
                            border-right: 1px solid #efefef;
                            border-bottom: 1px solid #efefef;
                            text-align: center;
                            p:nth-child(1) {
                                width: 100%;
                                height: 25px;
                                line-height: 1.1em;
                                font-size: 12px;
                                color: #999999;
                                word-break: break-all;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                            }
                            p:nth-child(2) {
                                margin-top: 8px;
                                span:nth-child(1) {
                                    font-size: 16px;
                                    color: #999999;
                                    font-weight: 700;
                                }
                                span:nth-child(2) {
                                    font-size: 12px;
                                    color: #999999;
                                }
                            }
                        }
                        .pro_active {
                            p{
                                color: #36b374 !important;
                                .t_active{
                                    color: #36b374 !important;
                                }
                            }
                        }
                    }
                }
            }
            .all_active {
                margin-top: 0;
            }
            .s_city {
                width: 100%;
                text-align: center;
                border-bottom: 1px solid #efefef;
                margin-top: 20px;
                img {
                    display: inline-block;
                    width: 100px;
                    height: 24px;
                }
            }
        }

    }
    .header_text {
        margin-top: 59px;
        background: #36B374;
        height: 42px;
        color: #fff;
        font-size: 32px;
        text-align: center;
        span:nth-child(2) {
            font-size: 12px;
        }
    }
    .main_list {
        min-height: 100vh;
        background-color: @base-background;
        .s_city {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #efefef;
            background-color: #fff;
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.04);
            img {
                display: inline-block;
                width: 65px;
                height: 12px;
                margin-bottom: -2px;
            }
        }
        .wrapper {
            background-color: #fafafa;
            margin-top: 24px;
            .reject {
                width: 100%;
                padding-bottom: 16px;
                .reject_item {
                    margin-left: 12px;
                    margin-right: 12px;
                    border-radius: 3px;
                    background: #fff;
                    box-shadow:0px 2px 15px 0px rgba(0,0,0,0.06);
                    .item_top{
                        padding: 16px;
                        box-sizing: border-box;
                        padding-bottom: 16px;
                    }
                    .title {
                        display: flex;
                        justify-content: space-between;
                        .title_text {
                            font-size: 16px;
                            font-weight: 700;
                            color: #2a2a2a;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            width: 87.2%;
                            line-height: 20px;
                        }
                        .title_tag {
                            width: 36px;
                            height: 18px;
                            font-size: 10px;
                            color: #ffffff;
                            border-radius: 9px;
                            text-align: center;
                            line-height: 20px;
                        }
                        .ss1{
                            background: #118BF5;
                        }
                        .ss2{
                            background: #FFA509;
                        }
                        .ss3{
                            background: #F75C32;
                        }
                    }

                    .info {
                        margin-top: 12px;
                        span:nth-child(1) {
                            display: inline-block;
                            width: 84px;
                            font-size: 14px;
                            color: #777;
                        }
                        span:nth-child(2) {
                            display: inline-block;
                            font-size: 14px;
                        }
                        span:nth-child(3) {
                            display: inline-block;
                            content: '';
                            margin: -8px 5px;
                            background: #999;
                            width: 1px;
                            height: 16px;
                            -webkit-transform: scaleY(0.5);
                            transform: scale(0.5);
                            -webkit-transform-origin: 0 0;
                            transform-origin: 0 0;
                        }
                        span {
                            font-size: 14px;
                            color: #777;

                        }
                        .info_time {
                            color: #36B374;
                        }
                    }
                    .info1 {
                        margin-top: 12px;
                        display: flex;
                        img {
                            width: 14px;
                        }
                        span:nth-child(2) {
                            font-size:14px;
                            font-weight:400;
                            color:rgba(143,143,143,1);
                            line-height:14px;
                            margin-left: 4px;
                        }

                    }
                    .line {
                        width: 100%;
                        height: 1px;
                        margin-top: 4px;
                    }
                    .status {
                        width: 100%;
                        padding: 15px 16px;
                        font-size: 14px;
                        color: #333333;
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        background: #fff;
                        p:nth-child(2) {
                            display: flex;
                            align-items: center;
                            span {
                                color: #999999;
                                font-size: 12px;
                            }
                        }
                        p>span>img {
                            width: 4px;
                            height: 7px;
                            margin-left: 4px;
                            margin-top:-3px;
                        }
                    }
                }
                .space {
                    width: 100%;
                    height: 24px;
                    background-color: #fafafa;
                }
            }
        }
    }
    .isNoBox{
        margin-top: 50%;
    }
}
</style>
